import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'
import { Loader } from '../../../../../common/components';

const ViewUserOther = loadable(() => import('./ViewUserOther'), {
    fallback: <Loader/>,
});
const UserOtherRoutes = ({ t, alert }) => {
  return [
    <Route key="view_user_other" exact path="/view/:id/others" element={<ViewUserOther t={t} alert={alert} />} />
  ];
};
UserOtherRoutes.propTypes = {
  t: PropTypes.func,
  alert: PropTypes.func
};
export default UserOtherRoutes;
